

const observerCbs = [];
let mainMtObserver = null;

/**
 *
 * @param {string|{root: HTMLElement, selector: string}} selector  CSS selector for statically rendered elements
 * @param {(el: HTMLElement, idx: number, els: HTMLElement[]) => any} initEachFn  Callback for initialization. Is given the same arguments as Array.prototype.map and Array.prototype.forEach functions
 * @param args Advanced configuration
 * @param {boolean} args.observe Either to observe dynamically added elements
 * @param {(el: HTMLElement) => void} args.observerFilterFn Function that tests inserted elements for initialization
 *
 * @returns {unknown[]} Array of whatever your initEachFn function returns
 */
export function initElements(selector, initEachFn, args = {}) {
    args = Object.assign({}, {
        observe: false,
        observerFilterFn: null,
    }, args);

    const root = typeof selector === "object" ? selector.root : document;
    const cssSelector = typeof selector === "object" ? selector.selector : selector;

    if (mainMtObserver && args.observe && typeof args.observerFilterFn === "function") {
        maybeInitMainMutationObserver();
        observerCbs.push((mutation => {
            [].slice.apply(mutation.nodeList).filter(args.observerFilterFn).forEach(initEachFn);
        }));
    }

    return [].slice.apply(root.querySelectorAll(cssSelector)).map(initEachFn);
}

function maybeInitMainMutationObserver() {
    if (!mainMtObserver && "MutationObserver" in  window) {
        mainMtObserver = new MutationObserver(mutations => mutations.forEach(mutation => {
            observerCbs.forEach(cb => cb(mutation));
        }));
        mainMtObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
}
